import Dialog from 'components/dialog/dialog';

export default Dialog;
